import React from 'react'
import { WebhookSubscriber } from '../../../interfaces/Webhook'
import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { WebhookSubscriberForm } from './WebhookSubscriberForm'
import { initialFormValues } from './config'

interface WebhookFormProps {
  onCreate: (success: boolean) => void
  handleSnackbar: (message: string, success: boolean) => void
}

const postWebhook = (dto: WebhookSubscriber) => {
  const url = new URL(`${ApiConfig.WebhookApi}`)
  return axios.post(url.toString(), dto)
}

export const WebhookForm: React.FC<WebhookFormProps> = ({
  onCreate,
  handleSnackbar
}) => {
  const { state, callApi } = useApi()

  const requestCreateWebhook = (webhook: WebhookSubscriber) => {
    callApi(postWebhook(webhook))
      .then(() => {
        handleSnackbar('Webhook creado correctamente', true)
        onCreate(true)
      })
      .catch((error) => {
        handleSnackbar(error, false)
        onCreate(false)
      })
  }

  if (state.status === Status.Loading) {
    return <Loading />
  }

  return (
    <WebhookSubscriberForm
      initialValues={initialFormValues}
      onSubmit={requestCreateWebhook}
    />
  )
}
